var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechnology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#6C63FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 14.9397L24 12.2725M18.6667 29.6095L29.3333 18.9406M24 36.2776L26.6667 33.6104M30 33.6104C31.8409 33.6104 33.3333 32.1177 33.3333 30.2763C33.3333 28.435 31.8409 26.9423 30 26.9423C28.1591 26.9423 26.6667 28.435 26.6667 30.2763C26.6667 32.1177 28.1591 33.6104 30 33.6104ZM18 21.6078C19.8409 21.6078 21.3333 20.1151 21.3333 18.2737C21.3333 16.4324 19.8409 14.9397 18 14.9397C16.1591 14.9397 14.6667 16.4324 14.6667 18.2737C14.6667 20.1151 16.1591 21.6078 18 21.6078ZM15.3333 36.2776C17.1743 36.2776 18.6667 34.7849 18.6667 32.9435C18.6667 31.1022 17.1743 29.6095 15.3333 29.6095C13.4924 29.6095 12 31.1022 12 32.9435C12 34.7849 13.4924 36.2776 15.3333 36.2776ZM32.6667 18.9406C34.5076 18.9406 36 17.4478 36 15.6065C36 13.7652 34.5076 12.2725 32.6667 12.2725C30.8257 12.2725 29.3333 13.7652 29.3333 15.6065C29.3333 17.4478 30.8257 18.9406 32.6667 18.9406Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.b41b9d861a5c4f4fb79ed8257173ea32.svg";
export { ForwardRef as ReactComponent };